'use client';

import './nav-search.scss';

import { useTranslation } from 'react-i18next';

import { Link } from '@sola/ark-core/atoms/link/link.js';
import { cn } from '@sola/ark-core/utils/helpers.js';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.js';
import { getPublicConfig } from '@sola/config/lib/getters.js';

interface NavSearchProps {
  className?: string;
}

export const NavSearch = ({ className }: NavSearchProps) => {
  const { t } = useTranslation(['articles', 'priority', 'common']);
  const { NEXT_PUBLIC_BASE_URL_DOTCOM } = getPublicConfig();

  return (
    <Link
      className={cn('NavSearch flex p-comfy-xs relative', className)}
      href={new URL('/search', NEXT_PUBLIC_BASE_URL_DOTCOM)}
      title={t('articles:search')}
      aria-label={t('articles:search')}
    >
      <ArkIcon iconName="search-sm" className="NavSearch__icon" size="1.5em" />
    </Link>
  );
};
